module.exports = __webpack_public_path__ + "img/progress_040.b49d20de.png";